(function ($) {

    if($('.section--animation').length){

      let scrollTimeout;
      const throttle = 50;

      const section = $('.section--animation');
      const background = section.find('.section__background');

      $(window).on('scroll', function() {

        if (!scrollTimeout) {
          scrollTimeout = setTimeout(function () {
            initAnimation(section, background);
            scrollTimeout = null;
          }, throttle);
        }
      });

      function initAnimation(section, background){
        const sectionTop = section.offset().top - 350;
        const scrollTop = $(window).scrollTop();
        const fadedInLine = sectionTop + 400;
        const startFadeOutLine = sectionTop + 1500;
        const fadedOutLine = sectionTop + 2500;
        const fadeLength = fadedOutLine - startFadeOutLine;

        if(scrollTop < sectionTop){
          background.stop(true, true).css('opacity', 0);
        }else if (scrollTop < fadedInLine){
          background.stop(true, true).css('opacity', (scrollTop - sectionTop) / (fadedInLine - sectionTop));
        }else if(scrollTop >= fadedInLine && scrollTop <= startFadeOutLine){
          background.stop(true, true).css('opacity', 1);
        }else if(scrollTop > startFadeOutLine && scrollTop < fadedOutLine){
          background.stop(true, true).css('opacity',  ((fadeLength - (scrollTop - startFadeOutLine)) / (fadedOutLine - startFadeOutLine)));
        }else{
          background.stop(true, true).css('opacity', 0);
        }
      }
    }

})(jQuery);
